import {
    FETCH_PARTNERS_REQUEST,
    FETCH_PARTNERS_SUCCESS,
    FETCH_PARTNERS_FAILURE,
    CREATE_PARTNER_REQUEST,
    CREATE_PARTNER_SUCCESS,
    CREATE_PARTNER_FAILURE,
    UPDATE_PARTNER_REQUEST,
    UPDATE_PARTNER_SUCCESS,
    UPDATE_PARTNER_FAILURE,
    DELETE_PARTNER_REQUEST,
    DELETE_PARTNER_SUCCESS,
    DELETE_PARTNER_FAILURE,
} from "../actions/types";

const initialState = {
    partners: [],
    pagination: {
        total: 0,
        page: 1,
        size: 10,
        pages: 1,
    },
    loading: false,
    error: null,
    message: "",
};

const partnerReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PARTNERS_REQUEST:
        case CREATE_PARTNER_REQUEST:
        case UPDATE_PARTNER_REQUEST:
        case DELETE_PARTNER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_PARTNERS_SUCCESS: {
            const payload = action.payload || {};

            return {
                ...state,
                loading: false,
                partners: payload.data || [],
                pagination: {
                    total: payload.total ?? 0,
                    page: payload.page ?? 1,
                    size: payload.size ?? 10,
                    pages: payload.pages ?? 1,
                },
                message: "Partners loaded successfully",
            };
        }

        case CREATE_PARTNER_SUCCESS:
            return {
                ...state,
                loading: false,
                partners: [action.payload, ...state.partners],
                message: "Partner created successfully",
            };

        case UPDATE_PARTNER_SUCCESS: {
            const updated = action.payload;

            return {
                ...state,
                loading: false,
                partners: state.partners.map((partner) =>
                    partner.partner_id === updated.partner_id
                        ? { ...partner, ...updated }
                        : partner
                ),
                message: "Partner updated successfully",
            };
        }

        case DELETE_PARTNER_SUCCESS:
            return {
                ...state,
                loading: false,
                partners: state.partners.filter(
                    (partner) => partner.partner_id !== action.payload
                ),
                message: "Partner deleted successfully",
            };

        case FETCH_PARTNERS_FAILURE:
        case CREATE_PARTNER_FAILURE:
        case UPDATE_PARTNER_FAILURE:
        case DELETE_PARTNER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default partnerReducer;